/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Manejando Inputs con Angular`}</h3>
    <p>{`Para enlazar un input con algún valor de nuestro estado utilizamos el atributo `}<inlineCode parentName="p">{`[(ngModel)]`}</inlineCode>{` y le asignamos algún valor de nuestro estado. Es muy importante añadir el módulo de Formularios, `}<inlineCode parentName="p">{`FormsModule`}</inlineCode>{`, a `}<inlineCode parentName="p">{`app.module.ts`}</inlineCode>{`.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// imports`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token imports"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` `}<span parentName="span" {...{
              "className": "token maybe-class-name"
            }}>{`FormsModule`}</span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span>{` `}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'@angular/forms'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

@`}<span parentName="code" {...{
            "className": "token function"
          }}><span parentName="span" {...{
              "className": "token maybe-class-name"
            }}>{`NgModule`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//...`}</span>{`
  `}<span parentName="code" {...{
            "className": "token literal-property property"
          }}>{`imports`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
    `}<span parentName="code" {...{
            "className": "token maybe-class-name"
          }}>{`BrowserModule`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    `}<span parentName="code" {...{
            "className": "token maybe-class-name"
          }}>{`FormsModule`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`       `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// add`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}</code></pre></div>
    <h3>{`Manejando eventos del DOM con Angular`}</h3>
    <p>{`Para manejar los eventos como `}<inlineCode parentName="p">{`onclick`}</inlineCode>{` u `}<inlineCode parentName="p">{`onsubmit`}</inlineCode>{`, Angular nos da atributos equivalentes a los cuales les asignamos la función a ejecutar como `}<inlineCode parentName="p">{`(ngSubmit)="handleSubmit($event)"`}</inlineCode>{`.`}</p>
    <p>{`Asi luce nuestro código de PokedexForm después de añadir el manejo de eventos a la aplicación.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-JS"
      }}><code parentName="pre" {...{
          "className": "language-JS"
        }}>{`//pokedex-form.compontent.ts
import { Component } from &#39;@angular/core&#39;;

@Component({
  selector: &#39;app-pokedex-form&#39;,
  templateUrl: &#39;./pokedex-form.component.html&#39;,
  styleUrls: [&#39;./pokedex-form.component.css&#39;]
})
export class PokedexFormComponent{
  pokemonId: string = &#39;&#39;

  constructor() { }

  onSubmit(e) {
    e.preventDefault()
    // Llamamos a la API
    this.pokemonId = &#39;&#39; // Reiniciamos el formulario
  }
}


//pokedex-form.compontent.html
&lt;form class=&quot;pokemon-form&quot; (ngSubmit)=&quot;handleSubmit($event)&quot;&gt;
  &lt;input
    class=&quot;pokemon-input&quot;
    type=&quot;text&quot;
    [(ngModel)]=&quot;pokemonId&quot;
    name=&quot;pokemonId&quot;
    placeholder=&quot;Busca tu pokemon&quot;
    autoComplete=&quot;off&quot;&gt;
  &lt;input type=&quot;submit&quot; class=&quot;pokemon-btn&quot; value=&quot;&quot;&gt;
&lt;/form&gt;`}</code></pre></div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;